import React, { useEffect, useState } from 'react';
import { Formik, useFormik, connect as formikConnect } from 'formik';
import { connect } from 'react-redux';
import {
  CheckBox,
  InputField,
  Upload,
  Select,
  MultiSelect,
  FormGroup,
  FormSectionTitle
} from '../../../components/form';
import {
  getUserAction,
  createUserAction,
  updateUserAction,
  checkEmailExistAction,
  changeUserPasswordAction
} from '../../../modules/users/Actions';
import {
  usersIsLoadingSelector,
  userByIdSelector,
  currentUserSelector,
  emailExistSelector
} from '../../../modules/users/Selectors';

import countriesList from './countriesList';
// import ArtisanForm from '../artisans/ArtisansForm';
import ArtisanMiniForm from './ArtisanForm';
import ApplicantMiniForm from './ApplicantForm';
import CustomerForm from './CustomerForm';
import SupplierForm from './SupplierForm';
// import CitiesList from './CitiesList';
import schema from './usersSchema';
import generator from 'generate-password';

// create Artisan Action

import { createArtisanAction } from '../../../modules/artisans/Actions';

// create Supplier Action

import { createSupplierAction } from '../../../modules/suppliers/Actions';

// create Customer Action

import { createCustomerAction } from '../../../modules/customers/Actions';
import CitiesList from './CitiesList';
// create Applicant

// import {
// --> TBH <--
// } from '../../../modules/'

import artisanSchema from '../artisans/artisansSchema';
import * as yup from 'yup';
import { withRouter } from 'react-router-dom';
import { globalFail } from '../../../modules/globalFail/Selector';
import { setRedirectFalse } from '../../../modules/globalFail/Action';
import { newErrorNotificationAction } from '../../../modules/notifications/Actions';
import { Modal } from '@material-ui/core';
import { authCurrentDefaultTypeSelecetor } from '../../../modules/auth/Selectors';
import getLangData from '../../../utils/getLangData';
import { Button } from 'react-bootstrap';
import api from '../../../helpers/api';
const profileLang = getLangData().profile_types;
const fieldsLang = getLangData().fields;
const buttonsLang = getLangData().buttons;
const options = [
  { value: '6', label: profileLang.applicant },
  { value: '4', label: profileLang.customer },
  { value: '3', label: profileLang.artisan },
  { value: '5', label: profileLang.supplier },
  { value: '8', label: profileLang.training_center }
];

const UsersForm = props => {
  const {
    user,
    userId,
    getUser,
    isLoading,
    updateUser,
    createUser,
    createArtisan,
    createSupplier,
    userData,
    setPage,
    fail,
    edit,
    redirect,
    redirectFalse,
    checkEmail,
    emailExists,
    errorNotification,
    changePassword,
    defaultUserType,
    userType
  } = props;

  const [formikValues, setFormikValues] = useState([]);
  const [open, setOpen] = useState(false);
  const [pages, setPages] = useState(['user']);
  const [validationErrors, setValidationErrors] = useState({});
  // const merged = () => schema().concat(artisanSchema());
  // console.log(merged());
  useEffect(() => {
    if (userId) {
      getUser(userId);
    }
    // console.log(typeof schema);
  }, [getUser, userId]);

  useEffect(() => {
    if (!edit) {
      redirect && setPage(formikValues);
      redirectFalse();
    }
  }, [redirect]);

  return (
    <Formik
      validationSchema={schema(!edit ? true : false)}
      initialErrors={schema().cast()}
      //    validationSchema={() => yup.lazy((values) => {
      //   values.useType === ['3'] && console.log('values.useType does exist')

      //   return schema().concat(artisanSchema())
      // })}
      enableReinitialize
      initialValues={userData ? { ...userData } : schema().cast()}
      onSubmit={async (values, { isValid }) => {
        if (emailExists) {
          errorNotification('Check Your Email');
          return;
        }
        const { email, ...valuesWithoutEmail } = values;
        if (edit) {
          if (values.email !== userData.email) {
            updateUser(values._id, values);
          } else {
            updateUser(values._id, valuesWithoutEmail);
          }
        } else {
          // console.log(isValid)
          // console.log('notvalid');
          createUser(values, values.userType, setPage);
          console.log(values.userType);
        }
      }}
    >
      {({ handleSubmit, values, setFieldValue, errors, isSubmitting }) => (
        <>
          {/*    {edit && (
    
          )}*/}
          <FormGroup
            disabled={isSubmitting}
            clicked={() => console.log(errors)}
            isLoading={isLoading}
            handleSubmit={handleSubmit}
            errors={errors}
            heading={
              edit
                ? `${fieldsLang.update} [${userData.firstName} ${userData.lastName}]`
                : buttonsLang.add_user
            }
          >
            {!userData?.emailVerified && defaultUserType === '1' && edit && (
              <div className='mb-3'>
                <Button
                  onClick={async () => {
                    console.log('ok', 'useeer');
                    try {
                      await api.post('/users/bulk-email-verification', {
                        emails: [userData.email]
                      });
                      window.location.reload()
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  Verify Account
                </Button>
              </div>
            )}
            {edit && defaultUserType === '0' && (
              <>
                <div
                  className='btn btn-primary'
                  onClick={() => {
                    setOpen(true);
                  }}
                  style={{ marginBottom: '25px' }}
                >
                  {buttonsLang.reset_password}
                </div>
                <Modal
                  open={open}
                  onClose={() => {
                    setOpen(false);
                  }}
                >
                  <div
                    style={{
                      width: '60%',
                      backgroundColor: 'white',
                      overflow: 'auto',
                      // top: !open ? '0%' : '60%',
                      // left: '50%',
                      bottom: '25vh',
                      left: '25%',
                      opacity: open ? 1 : 0,
                      transform: open ? 'translateY(0%)' : 'translateY(-100vh)',
                      // height: '100%',
                      transition: 'all .4s ease-in-out',
                      position: 'absolute',
                      padding: '50px',
                      outline: 'none'
                    }}
                  >
                    <FormSectionTitle>Change Password</FormSectionTitle>
                    <InputField
                      type='password'
                      label={fieldsLang.password}
                      name='password'
                      errorMessage={
                        values.password !== values.confirmPassword &&
                        'Password do not match'
                      }
                    />

                    <InputField
                      type='password'
                      label={fieldsLang.confirm_Password}
                      name='confirmPassword'
                    />
                    <button
                      className='btn btn-primary'
                      disabled={!values.password}
                      onClick={() => {
                        if (values.password && !values.confirmPassword) {
                          errorNotification('Check Your Password');
                        } else if (values.password !== values.confirmPassword) {
                          errorNotification('Check Your Password');
                        } else if (values.password === values.confirmPassword) {
                          changePassword({
                            userId: values._id,
                            password: values.password
                          });
                          setOpen(false);
                        } else {
                          setOpen(false);
                        }
                      }}
                    >
                      {buttonsLang.submit}
                    </button>
                  </div>
                </Modal>
              </>
            )}
            {/* <Modal
              open={open}
              onClose={() => {
                setOpen(false);
              }}
            >
              <FormSectionTitle>Change Password</FormSectionTitle>
              <InputField
                type="password"
                label="Password"
                name="password"
                errorMessage={
                  values.password !== values.confirmPassword &&
                  'Password do not match'
                }
              />

              <InputField
                type="password"
                label="Confirm Password"
                name="confirmPassword"
              />
            </Modal> */}
            {setFormikValues(values.userType)}
            {/* {Object.keys(errors).length === 0 && errors.constructor === Object && console.log('err', errors)} */}
            {setValidationErrors(errors)}
            {/* {console.log(validationErrors)} */}
            <InputField label={fieldsLang.first_name} name='firstName' />

            <InputField label={fieldsLang.last_name} name='lastName' />
            {/* <Upload
            // data={{ customerID: 'usads9123213k219d123' }}
            data={{ userID: '5fa7d806602784002c4c8033' }}
            name="picture"
            label="Profile Picture :"
            S3Bucket="warshatna-users"
            // API="customer/customer-category-image-signedurl/"
            API="users/user-profile-image-signedurl"
          /> */}
            {/* <button
            onClick={() => {
              const password = generator.generate({
                length: 10,
                numbers: true,
              });
              console.log(password)
            }}
          >
            click me
          </button> */}
            <InputField
              label={fieldsLang.email}
              name='email'
              emailError={emailExists}
              onBlur={() => {
                !edit && checkEmail(values.email);
                if (edit && userData.email !== values.email) {
                  checkEmail(values.email);
                }
              }}
            />

            {/* <Select
              label="Country"
              name="country"
              value={countriesList?.filter(
                (object) => values?.country?.indexOf(object.value) > -1
              )}
              options={countriesList}
              onChange={(value) => {
                setFieldValue('country', value.value);
              }}
            /> */}

            <Select
              label={fieldsLang.city}
              name='city'
              options={getLangData().cities}
            />
            <InputField label={fieldsLang.address} name='address' />
            <InputField label={fieldsLang.phone} name='phone' />

            <InputField label={fieldsLang.zip_code} name='zipCode' />

            {!userData ? (
              <MultiSelect
                inArray={true}
                label={fieldsLang.user_type}
                name='userType'
                options={options}
              />
            ) : (
              <div></div>
            )}
            {/* <CheckBox name="artisanTrue" /> */}
            {/* {values.userType.indexOf('3') !== -1 && (
            <ArtisanMiniForm values={values}></ArtisanMiniForm>
          )}
          {values.userType.indexOf('6') !== -1 && (
            <ApplicantMiniForm values={values} />
          )}
          {values.userType.indexOf('4') !== -1 && (
            <CustomerForm values={values} />
          )}
          {values.userType.indexOf('5') !== -1 && (
            <SupplierForm values={values} />
          )} */}
            {!edit ? (
              <>
                <InputField
                  label={fieldsLang.password}
                  type='password'
                  name='password'
                />
                <div
                  className='generatorBtn'
                  //  style={{border: 'none', backgroundColor: 'transparent', display: 'block', fontSize: '14px', marginTop: '-15px' }}
                  onClick={() => {
                    const password = generator.generate({
                      length: 10,
                      numbers: true
                    });
                    setFieldValue('password', password);
                    console.log(password);
                    // document.execCommand("copy")
                  }}
                >
                  Generate Password
                </div>
              </>
            ) : (
              <>
                {/* <FormSectionTitle>Change Password</FormSectionTitle>
              <InputField
                type="password"
                label="Password"
                name="password"
                errorMessage={
                  values.password !== values.confirmPassword &&
                  'Password do not match'
                }
              />

              <InputField
                type="password"
                label="Confirm Password"
                name="confirmPassword"
              /> */}
              </>
            )}
            {/* <CheckBox
            label="Email Verified"
            name="emailVerified"
            subLabel="Verify the Email"
            tip="Email is Not Verified"
          />

          <CheckBox
            label="status"
            name="status"
            subLabel="Activate User"
            tip="User is Deactivated"
          /> */}
          </FormGroup>
        </>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const userId = props.match?.params.id;

  return {
    isLoading: usersIsLoadingSelector(state),
    user: userByIdSelector(state, props.userId),
    // user: currentUserSelector(state)
    redirect: globalFail(state),
    emailExists: emailExistSelector(state),
    defaultUserType: authCurrentDefaultTypeSelecetor(state),
    emailVerified: state.auth?.user?.emailVerified,
    userType: state.auth?.user?.userType
  };
};

const mapDispatchToProps = {
  getUser: getUserAction,
  createUser: createUserAction,
  updateUser: updateUserAction,
  createArtisan: createArtisanAction,
  createSupplier: createSupplierAction,
  redirectFalse: setRedirectFalse,
  createCustomer: createCustomerAction,
  checkEmail: checkEmailExistAction,
  errorNotification: newErrorNotificationAction,
  changePassword: changeUserPasswordAction
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersForm);
